module.exports = __webpack_public_path__ + "static/media/tianshangshan_mobile.106e6dfc.webp";